import { ETheme } from 'types/user';

export const APP_NAME = 'П1';
export const THEMES = [
  {
    label: 'Light',
    value: ETheme.LIGHT,
  },
  {
    label: 'Dark',
    value: ETheme.DARK,
  },
];
export const LOCALE_EN = 'en_US';
export const LOCALE_RU = 'ru_RU';
export const LOCALES = [
  {
    label: 'English (United States)',
    value: LOCALE_EN,
  },
  {
    label: 'Russian (Russia)',
    value: LOCALE_RU,
  },
];
